var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-promo"},[_c('WelcomeBox'),_c('SocialMedia'),_c('Navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }